<template>
  <BaseButton
    button-class="tw:pl-[1px]! tw:absolute"
    circle
    icon="chevron-left"
    icon-size="lg"
    :label="getLocaleText('global.back')"
    label-class="tw:text-base tw:font-bold"
    new-design
    new-icon
    @click="emit('click')"
  />
</template>

<script setup lang="ts">
import { getLocaleText } from "shared/boot/i18n";
import { BaseButton } from "shared/components/base";

const emit = defineEmits(["click"]);
</script>
